import { differenceInDays, differenceInMonths, differenceInYears } from 'date-fns';
import { dateDisplay } from '../formatters';

export const DateOfBirthDateOfDeath = ({
  dateOfBirth,
  dateOfDeath,
  format,
}: {
  dateOfBirth: string | undefined;
  dateOfDeath: string | undefined;
  format: string | undefined;
}) => {
  if (!dateOfBirth || !dateOfDeath) return <div></div>;

  let age = differenceInYears(new Date(dateOfDeath), new Date(dateOfBirth)) + '';

  if (differenceInYears(new Date(dateOfDeath), new Date(dateOfBirth)) < 1) {
    age = differenceInMonths(new Date(dateOfDeath), new Date(dateOfBirth)) + ' months';
  }

  if (differenceInDays(new Date(dateOfDeath), new Date(dateOfBirth)) < 90) {
    age = differenceInDays(new Date(dateOfDeath), new Date(dateOfBirth)) + ' days';
  }

  const dateFormat = format?.replace('*', '');

  return (
    <div className="list-service-dob-dod">
      {dateDisplay(dateOfBirth, undefined, dateFormat)} - {dateDisplay(dateOfDeath, undefined, dateFormat)}
      {format?.includes('*') && differenceInDays(new Date(dateOfDeath), new Date(dateOfBirth)) > 1 ? `, aged ${age}` : null}
    </div>
  );
};
